export const production = {
  investmentUiBaseUrl: 'https://invest.myclassroomeconomy.org',
  digitalUiBaseUrl: 'https://digital.myclassroomeconomy.org',
  domainendpoint: 'https://myclassroomeconomy.org/',
  aemGraphQLEndpoint: 'https://corporate.vanguard.com/graphql/execute.json/myce-invest-learning/',
  aemImageBaseUrl: 'https://corporate.vanguard.com',
  development: false,
}
